const cdnBaseUrl = import.meta.env.VITE_PUBLIC_CDN_BASE_URL
const webOtpHost =
  (import.meta.env.VITE_PUBLIC_WEB_OTP_HOST as string | undefined) ||
  'myapoloan.com'

export {
  cdnBaseUrl,
  webOtpHost
}
